/**
 *
 * @module submitOrderWithPaymentMethodResponse
 *
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @class SubmitOrderWithPaymentMethodResponse
 *
 */
export default class SubmitOrderWithPaymentMethodResponse {

    /**
     *
     * @param {String} guid
     * @throws {InvalidArgumentException}
     * @note params out of order with spec to keep optional items at the end
     *
     */
    constructor(guid) {

        const errorMessage = {
            ctor: 'SubmitOrderWithPaymentMethodResponse(guid)',
            get guid() {
                return `${this.ctor} guid should be a String`;
            }
        };

        nonEmptyString(guid, errorMessage.guid, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.guid = guid;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/submitOrderWithPaymentMethodResponse.js